import { useDispatch } from "react-redux";
import { updateModulesOrderRequest } from "src/requests/modules/requestCreators";
import { useCallback } from "react";
import { ModuleId } from "../../globalTypes";
import { fetchAllModulesMetadata, fetchMetadataForModule } from "./thunks";
import { updateOrderOfAllModules } from "./actions";

export const useFetchModuleMetadataCallback = () => {
  const dispatch = useDispatch();
  const fetchModuleMetadata = (id: ModuleId) =>
    dispatch(fetchMetadataForModule(id));

  return useCallback(fetchModuleMetadata, [dispatch]);
};

export const useFetchModulesMetadataCallback = () => {
  const dispatch = useDispatch();
  const fetchAllModules = () => dispatch(fetchAllModulesMetadata());

  return useCallback(fetchAllModules, [dispatch]);
};

type UpdateModulesOrder = (
  modulesOrder: Record<number, number>
) => Promise<void>;
type UseUpdateModulesOrder = () => UpdateModulesOrder;

export const useUpdateModulesOrder: UseUpdateModulesOrder = () => {
  const dispatch = useDispatch();

  const updateModulesOrder: UpdateModulesOrder = async (modulesOrder) => {
    try {
      await updateModulesOrderRequest(modulesOrder);
      dispatch(updateOrderOfAllModules(modulesOrder));
    } catch (_) {
      throw new Error("Error during modules order update");
    }
    return Promise.resolve();
  };

  return updateModulesOrder;
};
